import ReducerGenerator from '../../lib/ReducerGenerator'

const generator = new ReducerGenerator('census', '/censuses')
const reducer = generator.generate()

export default reducer
